import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Main } from './components/main'
import { appStore } from './appStore'
import { TopLevelErrorBoundary } from './components/top-level-error-boundary'
import {
  LoadableAnswersMain,
  LoadableOnlineMain
} from './components/main-loadables'
import { LoadableFormBuilder } from './lib/form-builder/formbuilder-loadable'

ReactDOM.render(
  <Provider store={appStore}>
    <TopLevelErrorBoundary>
      <Main />
    </TopLevelErrorBoundary>
  </Provider>,
  document.getElementById('root')
)

let hasPreloaded = false
export function preloadHubItems() {
  const state = appStore.getState()
  const hub = state.hub

  if (!hasPreloaded && hub.length > 0) {
    hasPreloaded = true

    return Promise.all(
      hub.map((item) => {
        if (item.type === 'answers') {
          return LoadableAnswersMain.preload().catch((e) =>
            console.warn('Failed to preload answers', e)
          )
        } else if (item.type === 'online') {
          return LoadableOnlineMain.preload().catch((e) =>
            console.warn('Failed to preload online', e)
          )
        } else if (item.type === 'form') {
          return LoadableFormBuilder.preload().catch((e) =>
            console.warn('Failed to form builder', e)
          )
        }
      })
    )
  }

  return Promise.resolve()
}
